var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.875H1.125C0.917578 0.875 0.75 1.04258 0.75 1.25V8.75C0.75 8.95742 0.917578 9.125 1.125 9.125H10.875C11.0824 9.125 11.25 8.95742 11.25 8.75V1.25C11.25 1.04258 11.0824 0.875 10.875 0.875ZM9.92813 2.15117L6.23086 5.02813C6.13945 5.09961 6.01172 5.09961 5.92031 5.02813L2.22188 2.15117C2.20793 2.14041 2.19771 2.12556 2.19263 2.1087C2.18755 2.09183 2.18788 2.0738 2.19357 2.05714C2.19925 2.04047 2.21001 2.026 2.22433 2.01575C2.23866 2.00551 2.25583 2 2.27344 2H9.87656C9.89417 2 9.91134 2.00551 9.92567 2.01575C9.93999 2.026 9.95075 2.04047 9.95643 2.05714C9.96212 2.0738 9.96245 2.09183 9.95737 2.1087C9.95229 2.12556 9.94207 2.14041 9.92813 2.15117Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ef3920ef8fca9b484e58e7e66fff0d90.svg";
export { ForwardRef as ReactComponent };